<template>
    <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
	<div class="contacts-9 py-lg-5 py-md-4">
		<div class="container">
			<div class="header-sec text-center mb-5">
				<br />
				<h1 class="title-w3l">
					Invalid Verification Code
				</h1>
			</div>
			<div class="contactct-fm map-content-9">
				<p>You entered an invalid verification code. Check your emails for the right code or sign up again to get another verification code.</p>
			</div>
		</div>
	</div>
</section>
</template>

<script setup lang="ts">
useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Invalid verification code`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - You entered an invalid verification code. Sign up again to get another verification code.`,
    }
  ]
});
</script>



<style scoped>

</style>